<template>
  <svg width="13" height="30" xmlns="http://www.w3.org/2000/svg">
    <g class="arrow" transform="translate(-789 -1921)" :fill="fill">
      <path d="M794.967205 1950.78218c.146136.14515.334895.21782.529743.21782.194848 0 .383607-.07267.529743-.21782l5.754105-5.71776c.292272-.29043.292272-.75632 0-1.04674-.292211-.29049-.761125-.29049-1.053336 0l-4.481565 4.45319v-26.72665c0-.41144-.334895-.74422-.748947-.74422-.414052 0-.748947.33278-.748947.74422v26.72665l-4.475415-4.45319c-.292211-.29049-.761125-.29049-1.053336 0-.292333.29042-.292333.75631 0 1.04674l5.747955 5.71776z" id="Fill-1"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      default: '#393634'
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/icons/icon-slide-arrow.vue